import { render } from "./ListaPedidosView.vue?vue&type=template&id=df9d9724&scoped=true"
import script from "./ListaPedidosView.vue?vue&type=script&lang=js"
export * from "./ListaPedidosView.vue?vue&type=script&lang=js"

import "./ListaPedidosView.vue?vue&type=style&index=0&id=df9d9724&scoped=true&lang=css"

import exportComponent from "C:\\SGCAD24\\Desenvolvimento\\Corofergs\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df9d9724"]])

export default __exports__